module.exports = __webpack_public_path__ + "assets/img/3e3afa134ca4502b7987983c0d53d0fe.svg";